import {
  PhoneField as PhoneFieldBase,
  type PhoneFieldChangeValue,
} from "@mindlercare/ui-web";
import { useDemo } from "contexts/DemoContext";
import { ComponentProps } from "react";

type BaseProps = Omit<ComponentProps<typeof PhoneFieldBase>, "isDemo">;

export type { PhoneFieldChangeValue };

export const PhoneField = (props: BaseProps) => {
  const isDemo = useDemo();

  return <PhoneFieldBase {...props} isDemo={isDemo} />;
};
